import {IJSONResponse} from './json-response.types';

export enum TypeAccountRoles {
  OWNER = 'ROLE_OWNER',
  ADMIN = 'ROLE_ADMIN',
  FUNCTIONAL_ADMIN = 'ROLE_FUNCTIONAL_ADMIN',
  DIRECTOR = 'ROLE_DIRECTOR',
  PROJECT_MANAGER = 'ROLE_PROJECT_MANAGER',
  MANAGER = 'ROLE_MANAGER',
  WORKER = 'ROLE_WORKER',
  CUSTOMER = 'ROLE_CUSTOMER',
  VIEWER = 'ROLE_VIEWER',
}

export interface IUserAccount {
  id: number;
  userLogin: string;
  createdDate: string;
  lastLoginDate: string;
  active: boolean;
  roles: TypeAccountRoles[];
  position: string;
  email?: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  patronymic: string;
  companyId?: string;
  comments: string;
  photo?: string;
  photoMimeType?: string;
  needToChangePasswd: boolean;
  photoFileSize: number;
  password: string;
  checkPassword: string;
  homeAddress?: string;
  homeAddressLongitude?: number;
  homeAddressLatitude?: number;
  userPrincipalId: number;
  uid: string;
}

export interface IUserAccountPostBody extends Omit<Partial<IUserAccount>, 'userLogin' | 'email'> {
  userLogin: string;
  email: string;
}

export interface IJSONResponseListUserAccountDto extends IJSONResponse {
  data: IUserAccount[];
}

export interface IUserAccountSpec extends Omit<Partial<IUserAccount>, 'id'> {
  isActive?: boolean[] | boolean;
  fio?: string;
}
